<style lang="scss" src='./WeatherInfo.scss' scoped ></style>
<template src="./WeatherInfo.html"></template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import VuePullRefresh from "vue-pull-refresh";
import WeatherWidget from "@/components/weather/WeatherWidget.vue";
import WeatherItem from "./weatherItem/WeatherItem.vue";
import MicroWeatherItem from "./microWeatherItem/MicroWeatherItem";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "WeatherInfo",
  components: {
    Carousel,
    Slide,
    WeatherWidget,
    WeatherItem,
    MicroWeatherItem,
    "vue-pull-refresh": VuePullRefresh,
  },
  props: {
    microWeather: {
      required: true,
    },
    localWeather: {
      required: true,
    },
    weatherPrecipitation: {
      required: true,
    },
    dailyTemps: {
      required: false,
    }
  },
  data() {
    return {
      microText: "microText",
      localText: "localText",
      maxHeightWeather: 600,
    };
  },
  computed: {
    ...mapState("Dashboard", {}),

    ...mapState(["course", "user"]),
  },

  methods: {
    getPrecipitation(station) {
      let precipitation = null
        this.weatherPrecipitation.map(precipitationValue => {
            if(precipitationValue.station.name == station.station.name){
                precipitation = precipitationValue
            }
        })

      return precipitation;
    },

    getMicroTitle(station) {
      return `${station.station.name} ${this.$t("general.microWeather")}`;
    },

    adjustSensorListHeight() {
      const self = this;
      // eslint-disable-next-line
      const sensorHeightInterval = setInterval(function () {
        if (self.$refs.weatherContainer) {
          self.maxHeightWeather = window.innerHeight - 94;
        }
      }, 0);
      // eslint-disable-next-line
      setTimeout(function () {
        clearInterval(sensorHeightInterval);
      }, 5000);
    },

    ...mapActions("Dashboard", []),
    ...mapMutations("Dashboard", ["setSelectedAlert"]),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.adjustSensorListHeight();
  },
};
</script>
